module.exports = __webpack_public_path__ + "/bundle/asset/admission2-2-7cc012443378698a3819a793608ab477.png";